"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestoreStrategy_1 = require("./RestoreStrategy");
var AllRestoreStrategyBuilder = /** @class */ (function () {
    function AllRestoreStrategyBuilder() {
    }
    AllRestoreStrategyBuilder.prototype.build = function () {
        return new RestoreStrategy_1.default('All');
    };
    return AllRestoreStrategyBuilder;
}());
exports.default = AllRestoreStrategyBuilder;
//# sourceMappingURL=AllRestoreStrategyBuilder.js.map